import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// @ts-ignore
import whoWe from '../images/who-we.jpg';
// @ts-ignore
import icon from '../images/icon.png';
import bosco from '../images/ivan-bosco.jpg';

const WhoAreWe = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div 
// @ts-ignore
      className="container max-w-screen-lg pt-3 pb-3 ">
        <div 
// @ts-ignore
        className="bg-grey">
          <h1 
// @ts-ignore
          className="py-3 text-3xl md:text-5xl font-bold text-[#A81414]">Святий Іван Боско</h1>
        </div>
        <div 
// @ts-ignore
        className="text-justify hyphens-auto" id="section1">
          <div 
// @ts-ignore
          className="pt-3 pb-3 text-lg font-semibold">
              16 серпня 1815, Кастельнуово-Дон-Боско — 31 січня 1888, Турин
          </div>
          <div 
// @ts-ignore
          className="pb-3">
            Святий Іван Боско, якого весь світ знає як дон Боско, народився 16 серпня 1815 року в селі Беккі на півночі Італії. У дитинстві він мав пророчий сон: бачив себе серед гурту хлопців, одні з яких славили Бога, а інші — зневажали Його. Він кинувся захищати Ім’я Боже, але його спинив Чоловік, який сказав: «Не стусанами, а добротою і лагідністю ти маєш завоювати цих своїх друзів… Я дам тобі Вчительку, яка навчить тебе мудрості». Так Господь Ісус повчав святого ще в дитинстві, а Богородиця протягом усього життя була його Покровителькою.
          </div>
          <div 
// @ts-ignore
          className="relative flex gap-10 max-md:flex-col">
            <img 
// @ts-ignore
            className="object-cover md:max-w-[400px] rounded-xl" src={bosco} alt="" />
            <div 
// @ts-ignore
            className="pb-3">
              Іван Боско став священником у 26 років. Своє священниче служіння розпочав у Турині, де багато бідних та безхатніх підлітків шукали прожитку. По неділях отець Боско збирав їх у церкві, а потім шукав приміщення, де можна було б із ними займатися, не порушуючи життя храму.<br /><br />
              Перша ораторія (місце для молитви) постала на околиці Турина, у Вальдокко. Там хлопці опановували знання, ремесло, а найголовніше — вчилися жити вірою. Прикладами християнської педагогіки для отця Боско були святий Альфонс Марія Лігуорі, святий Філіп Нері та святий Франциск Сальський. Навіть засноване ним згромадження не носить його імені: «Ми зватимемося салезіянами», — говорив він. Для доброго виховання отець Боско вважав необхідною до прочитання добру літературу, тому 1861 року заснував друкарню для дитячих книжок і брошур, які частково й сам писав.            </div>
          </div>
          <div 
// @ts-ignore
          className="pt-3 pb-3">
          </div>
          <div 
// @ts-ignore
          className="pt-3 pb-3">
            Отець Боско не вимагав від своїх вихованців «очей, зведених у небеса», і не закликав до надзвичайних аскетичних практик «задля святості». Він казав, що святий Йосиф і Діва Марія не робили нічого подібного, але все, що вони здійснювали, — це було виконання волі Божої. Такий підхід до салезіянської аскези привів до слави вівтаря самого отця Боско, його наступника — отця Михайла Руа, його вихованця Домініка Савіо, колишнього вихованця Луїджі Оріоне, співзасновницю Дочок Марії Помічниці християн — Марію Домініку Маццарелло, єпископів Луїджі Версільйо та Калікста Караварьо — місіонерів і мучеників у Китаї.          </div>
          <div 
// @ts-ignore
          className="pt-3 pb-3">
            Отця Боско проголосив святим 1934 року Папа Пій XI, який був особисто з ним знайомий.
          </div>
        </div>
      </div>
    </>
  );
};

export default WhoAreWe;
